import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Select from 'react-select';

import { getMachinesSubgroup, getGroup, getSubgroup, setRowInReducer, setInitialState } from '../../../actions/resources/MachinesActions';
import i18n from '../../../i18n/i18n';
import immutable from 'seamless-immutable';
import AddMachinesSubgroup from './AddMachinesSubgroup';
import checkboxHOC from "react-table/lib/hoc/selectTable";
const CheckboxTable = checkboxHOC(ReactTable);
export class ViewMachinesSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: this.props.edit,
            showFilters: false,
            selection: [],
            selectAll: false,
        };
    }

    componentDidMount() {
        if (this.props.machinesGroupDropdown.length == 0) {
            this.props.getGroup();
        }
        if (this.props.machinesSubgroupDropdown.length == 0) {
            this.props.getSubgroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMachinesSubgroup(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');
        }
        if (nextProps.machinesSubgroupsPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.props.handleClose();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMachinesSubgroup(wrapped.state);
            this.props.setInitialState('machinesSubgroupsPostingSuccess');
        }
        this.setState({
            add: nextProps.add,
            showFilters: nextProps.showFilters,
            machinesGroupDropdown: immutable.asMutable(nextProps.machinesGroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            groupFetching: nextProps.groupFetching,
            groupFetchingFailed: nextProps.groupFetchingFailed,
            machinesSubgroupDropdown: immutable.asMutable(nextProps.machinesSubgroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            subgroupFetching: nextProps.subgroupFetching,
            subgroupFetchingFailed: nextProps.subgroupFetchingFailed,
        })
        if (nextProps.add == true && nextProps.edit == false) {
            this.props.setInitialState('machineSubgroupObj');
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
        }
    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.machine_subgroup.filter((machine) => {
                    return machine.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'machineSubgroupObj');
            }
        });
        this.props.setSelection(selection, 'machine_subgroup');
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
        this.props.setSelection(selection, 'machine_subgroup');

    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    render() {
        let content;
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#ACDAF1" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        content =
            <div className="page">
                <CheckboxTable data={this.props.machine_subgroup}
                    columns={this.columns}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    showPaginationTop
                    showPaginationBottom={false}
                    pages={this.props.machinesSubgroupsPages}
                    loading={this.props.machinesSubgroupsFetching}
                    manual
                    onFetchData={(state, instance) => this.props.getMachinesSubgroup(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddMachinesSubgroup add={this.state.add} edit={this.props.edit}
                    handleClose={this.props.handleClose} />}
            </div>

        return (
            <div>
                {content}
            </div >
        )
    }

    columns = [
        {
            Header: i18n.t('Machine group name'),
            accessor: 'pogonska_masina_grupa_naziv',
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.machinesGroupDropdown}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Title'),
            accessor: 'naziv',
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.machinesSubgroupDropdown}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Icon name'),
            accessor: 'ime_ikonice',

        },
        {
            Header: i18n.t('Priority'),
            accessor: 'prioritet',
        },
        {
            Header: i18n.t('Color'),
            accessor: 'boja',
        },
    ];
};

function mapStateToProps(state) {
    return {
        machinesGroupDropdown: state.machinesReducer.machinesGroupDropdown,
        groupFetching: state.machinesReducer.groupFetching,
        groupFetchingFailed: state.machinesReducer.groupFetchingFailed,
        machine_subgroup: state.machinesReducer.machine_subgroup,
        machinesSubgroupsFetching: state.machinesReducer.machinesSubgroupsFetching,
        machinesSubgroupsFetchingFailed: state.machinesReducer.machinesSubgroupsFetchingFailed,
        machinesSubgroupsPages: state.machinesReducer.machinesSubgroupsPages,
        machinesSubgroupDropdown: state.machinesReducer.machinesSubgroupDropdown,
        deleted: state.machinesReducer.deleted,
        machinesSubgroupsPostingSuccess: state.machinesReducer.machinesSubgroupsPostingSuccess,
        subgroupFetching: state.machinesReducer.subgroupFetching,
        subgroupFetchingFailed: state.machinesReducer.subgroupFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        getSubgroup: () => dispatch(getSubgroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
        getMachinesSubgroup: (state, instance) => dispatch(getMachinesSubgroup(state, instance))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewMachinesSubgroup)